var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('iframe',{staticClass:"iframe",attrs:{"src":"https://wanghongtoutiao.feishu.cn/docx/I15MdArhtolsWXxoS7tcqT6SnXg?from=from_copylink","frameborder":"0"}})])
}]

export { render, staticRenderFns }